import script from "./CoberturaSecao.vue?vue&type=script&setup=true&lang=js"
export * from "./CoberturaSecao.vue?vue&type=script&setup=true&lang=js"

import "./CoberturaSecao.vue?vue&type=style&index=0&id=5c4e510c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4e510c"]])

export default __exports__